'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

var _draftjsConstants = require('../draftjsConstants');

// Lib
exports.default = function (editorState, style) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();

    contentState = _draftJs.Modifier.splitBlock(contentState, selection);
    if (style) {
        contentState = _draftJs.Modifier.setBlockType(contentState, contentState.getSelectionAfter(), style);
    }
    return _draftJs.EditorState.push(editorState, contentState, _draftjsConstants.EditorChangeType.SPLIT_BLOCK);
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/customRichUtils/insertNewline.js
// module id = 1715
// module chunks = 0